﻿import { Directive, ElementRef, OnInit, Input } from '@angular/core';
import { AuthorizationService } from '../../services/authorization.service';


@Directive({
    selector: '[HideIfUnauthorized]'
})
export class HideIfUnauthorizedDirective implements OnInit {
    @Input('HideIfUnauthorized') permission: number; // Required permission passed in
    @Input('FunctionId') functionid: string;
    constructor(private el: ElementRef, private authorizationService: AuthorizationService) { }
    ngOnInit() {
        let isadmin: boolean = false;
        var aa = localStorage.getItem('currentUser');
        if (aa) {

            let data = JSON.parse(aa);
            if (data != null && (data.user_name == "admin" || data.is_admin == "1")) {
                isadmin = true;
            }
        }
            if (!this.authorizationService.hasPermission(this.permission, this.functionid) && isadmin == false) {
            this.el.nativeElement.style.display = 'none';
        }
    }
}